<template>
	<div class="buy-packages-confirmation-vue">
					
		<form ref="form" class="ui form" method="post">
			<div class="ui vertically padded grid">
				<div class="one column row">
					<div class="column">
						<table class="ui table">
							<tbody>
								<tr v-if="selectedPackages.length == 0">
									<td colspan="3">
										<p><strong>Vaša košarica je prazna.</strong> <a :href="this.route('nakup-gradiva')">Nazaj v trgovino</a>.</p>
									</td>
								</tr>
								<template v-else>
									<tr class="package-row" v-for="pack in selectedPackages">
										<td class="left aligned middle aligned one wide">
											<button class="ui button circular icon mini red removeItem" v-on:click="removePackage(pack)" type="button">
												<i class="icon remove"></i>
											</button>
										</td>
							
										<td class="left aligned middle aligned">
											<div class="ui items">
												<div class="item cover-and-title">
													<div class="ui tiny image">
														<img v-on:error="onImageError" alt="naslovnica" :src="'images/packages/' + (pack.legacyId ? pack.legacyId : pack.creditId) + '.jpg'">
													</div>
													<div class="middle aligned content">
														<h3 class="ui header">{{pack.title}}</h3>
														<div class="description">
															<p>{{pack.description}}</p>
														</div>
													</div>
												  </div>
											</div>
										</td>
										
										<td class="packagePrice left aligned middle aligned collapsing">
											{{ pack.price | formatPrice }}
										</td>
									</tr>
								</template>
							</tbody>
							<tfoot>
								<tr>
									<th colspan="2" class="right aligned price-description-column">
										<p>Skupaj</p> 
										<p>DDV</p>
										<p>
											<strong>Skupaj z DDV</strong>
										</p>
									</th>
									<th class="left aligned collapsing prices-column">
										<p>{{ netPrice | formatPrice }}</p>
										<p>{{ taxPrice | formatPrice }}</p>
										<p>
											<strong>{{ price | formatPrice }}</strong>
										</p>
									</th>
								</tr>
							</tfoot>
						</table>
					</div>
				</div>
												
				<div class="one column row">
					<div class="column">
						<template v-if="teacher">
							<h3>Izberite plačnika</h3>
							<p>Plačnik je lahko vaša šola ali pa ste to vi sami. Če bo do 15. septembra gradiva naročilo več učiteljev z vaše šole, bomo na šolo po tem datumu poslali zbirni račun za vsa naročila. Šola mora račun poravnati v 30 dneh, gradiva pa boste lahko začeli uporabljati takoj.</p>
							<p>Če boste plačnik sami, boste gradiva lahko začeli uporabljati po plačilu predračuna, ki ga boste prejeli po e-pošti.</p>
						</template>

						<p>Za uporabo portala in izbranega interaktivnega učnega kompleta potrebujete zanesljivo in dovolj hitro spletno povezavo, spletni brskalnik <a href="https://www.google.com/chrome/browser/desktop/index.html" target="_blank">Chrome</a> / <a href="https://www.mozilla.org/sl/firefox/new/" target="_blank">Firefox&nbsp;16.0+</a> / <a href="https://support.apple.com/en_US/downloads/safari" target="_blank">Safari 6.0+</a> (priporočamo predvsem brskalnik Chrome). </p>

						<h3  v-if="!teacher">Podatki za plačilo</h3>
					</div>
				</div>

				<div class="one column row" id="form_wrapper">	
					<div class="column">
						<div class="inline fields" id="purchase-type" v-if="teacher">
							<div class="field">
								<div class="ui radio checkbox">
									<input type="radio" id="purchase_type_school" name="purchase_type" value="school" v-model="customer.type" v-validate="validation.customer">
									<label for="purchase_type_school">šola</label>
								</div>
							</div>
							<div class="field">
								<div class="ui radio checkbox">
									<input type="radio" id="purchase_type_person" name="purchase_type" value="personal" v-model="customer.type" v-validate="validation.customer">
									<label for="purchase_type_person">jaz osebno (po e-pošti prejmem predračun)</label>
								</div>
							</div>
							<div v-if="errors.has('purchase_type')" v-cloak class="ui basic red pointing prompt label visible">{{errors.first('purchase_type')}}</div>
						</div>
						<template v-else>
							<div class="field" id="name">
								<input type="text" name="name" v-model="customer.name" placeholder="Ime*" v-validate="validation.name"/>
								<div v-if="errors.has('name')" v-cloak class="ui basic red pointing prompt label visible">{{errors.first('name')}}</div>
							</div>
										
							<div class="field"  id="surname" >
								<input type="text" name="surname" v-model="customer.surname" placeholder="Priimek*"  v-validate="validation.surname"/>
								<div v-if="errors.has('surname')" v-cloak class="ui basic red pointing prompt label visible">{{errors.first('surname')}}</div>
							</div>
						</template>
						<div class="field" v-if="!teacher || customer.type == 'personal'">
							<input type="text" name="address" v-model="customer.address" placeholder="Naslov*"  v-validate="validation.address"/>
							<div v-if="errors.has('address')" v-cloak class="ui basic red pointing prompt label visible">{{errors.first('address')}}</div>
						</div>
						
						<div class="field" v-if="!teacher || customer.type == 'personal'">
							<input type="text" name="zip" v-model="customer.zip" placeholder="Poštna številka*"  v-validate="validation.zip"/>
							<div v-if="errors.has('zip')" v-cloak class="ui basic red pointing prompt label visible">{{errors.first('zip')}}</div>
						</div>
						
						<div class="field" v-if="!teacher || customer.type == 'personal'">
							<input type="text" name="code" v-model="customer.post" placeholder="Pošta*"  v-validate="validation.post"/>
							<div v-if="errors.has('code')" v-cloak class="ui basic red pointing prompt label visible">{{errors.first('code')}}</div>
						</div>

						<div class="ui field">
							<div class="ui checkbox" style="display: block;">
								<input type="checkbox" id="user_agreement" name="user_agreement" v-validate="validation.consent" data-vv-as="razred">
								<label for="user_agreement">Strinjam se s <a :href="this.route('splosni-pogoji')" target="_blank">pogoji uporabe in nakupa</a>*.</label>
								<div v-if="errors.has('user_agreement')" v-cloak class="ui basic red pointing prompt label visible">{{errors.first('user_agreement')}}</div>
							</div>
						</div>
						
						<p v-if="asSchool"><small><span class="asterisk">*</span> Podatek je obvezen.</small></p>

						<p v-if="asSchool"><small>Cene vključujejo 9,5- oz. 22-odstotni DDV. Naročilnica je sestavljena v enem izvodu in ima status pogodbe, sklenjene med kupcem in Založbo Rokus Klett, d. o. o., Stegne 9 b, 1000 Ljubljana.</small></p>
						<div class="personal-terms ui message" v-if="!asSchool">

							<p><small><span class="asterisk">*</span> Podatki o naslovu so obvezni in jih potrebujemo za izstavitev računa in s tem za izvedbo pogodbe o naročilu licenc. Te podatke hranimo še 2 leti od vašega zadnjega nakupa.</small></p>

							<p>
								<small>Zahtevate lahko dostop do svojih osebnih podatkov, njihovo popravo ali izbris ali omejitev njihove obdelave. Prav tako imate pravico do ugovora obdelavi in pravico do prenosljivosti podatkov. Vprašanja ali pripombe glede obdelave vaših osebnih podatkov lahko naslovite na našega pooblaščenca za varstvo osebnih podatkov: <a href="mailto:osebni.podatki@rokus-klett.si">osebni.podatki@rokus-klett.si</a>. Če menite, da je pri obdelavi osebnih podatkov prišlo do kršitve veljavne zakonodaje, lahko podate pritožbo pri Informacijskem pooblaščencu.</small>
							</p>

							<p>
								<small>Cene vključujejo 9,5- oz. 22-odstotni DDV. Naročilnica je sestavljena v enem izvodu in ima status pogodbe, sklenjene med kupcem in Založbo Rokus Klett, d. o. o., Stegne 9 b, 1000 Ljubljana (v nadaljevanju ponudnik). Kupec ima pravico, da brez navedbe razlogov v 14 dneh odstopi od te pogodbe. Odstopni rok poteče v 14 dneh od dne, ko kupec pridobi licenco ali jo namesto njega pridobi tretja oseba, ki jo v ta namen določi kupec. Za uveljavitev pravice do odstopa mora kupec podjetje Založba Rokus Klett, d. o. o., o svoji odločitvi o odstopu od te pogodbe obvestiti z nedvoumno izjavo. V ta namen lahko (neobvezno) uporabi priloženi <a href="/storage/Obrazec_uveljavitev_pravic.pdf" download>vzorčni odstopni obrazec</a>. Odstop od pogodbe sporoči: na e-naslov <a href="mailto:reklamacije@rokus-klett.si">reklamacije@rokus-klett.si</a> ali na naslov Založba Rokus Klett, d. o. o., Stegne 9 b, 1000 Ljubljana. Da se rok za odstop od pogodbe upošteva, zadošča, da je obvestilo v zvezi z uveljavljanjem pravice kupca do odstopa od pogodbe poslano pred iztekom roka za odstop od te pogodbe. Če kupec od te pogodbe odstopi, mu Založba Rokus Klett, d. o. o., brez nepotrebnega odlašanja in v vsakem primeru najpozneje v 14 dneh od dneva prejetja obvestila o odstopu od te pogodbe povrne vsa prejeta plačila. Takšno povračilo Založba Rokus Klett, d. o. o., izvede z enakim plačilnim sredstvom, kot je bilo uporabljeno pri izvedbi prvotne transakcije, razen če je izrecno dogovorjeno drugače; v nobenem primeru pa zaradi tega povračila kupec ne nosi nikakršnih stroškov. Ponudnik uporabnikom ali registriranim uporabnikom ne jamči, da bo uporaba njegovih aplikacij popolnoma neprekinjena, vedno na voljo ali da bo upravičila njihova pričakovanja v zvezi z aplikacijo. Ponudnik prav tako ni odgovoren za telefonske in mrežne povezave ter storitve, s pokritostjo območja ali prekinitvijo zveze vred. V primeru napak pri delovanju storitev ima uporabnik pravico zahtevati, da ponudnik odpravi pomanjkljivosti pri opravljeni storitvi ali vrne del plačanega zneska v sorazmerju s pomanjkljivostjo pri opravljeni storitvi ali ponovno opravi storitev ali vrne plačani znesek. Uporabnik lahko navedene zahtevke uveljavlja le, če ponudnika na e-naslov reklamacije@rokus-klett.si obvesti o napaki najkasneje v 2 mesecih od odkritja napake in v 2 letih od nakupa. Uporabnik mora v obvestilu o napaki natančneje opisati napako in ponudniku omogočiti, da obstoj napake na storitvi preveri. Obvestilo o odstopu mora uporabnik podati z nedvoumno izjavo, iz katere jasno izhaja, da odstopa od pogodbe in da ima storitev napako. Če obstoj napake na storitvi ni sporen, ponudnik najpozneje v roku 8 dni ugodi uporabnikovi zahtevi.. Če je obstoj napake na storitvi sporen, mora ponudnik uporabniku pisno odgovoriti na zahtevo najpozneje v 8 dneh po njenem prejemu. Vsa obvestila in pošiljke se štejejo za pravočasne, če so oddani najkasneje na zadnji dan roka. Aplikacije ponudnika lahko vsebujejo povezave na različne zunanje strani, kot so na primer druga internetna spletišča, posamezne strani ali drugi viri. Za dostopnost, vsebino ali napake zunanjih povezav ponudnik ne odgovarja. Ponudnik ne priznava nobenega izvajalca izvensodnega reševanja potrošniških sporov kot pristojnega za reševanje potrošniškega spora, ki bi ga potrošnik lahko sprožil v skladu z Zakonom o izvensodnem reševanju potrošniških sporov. V skladu s tem zakonom ponudnik objavlja elektronsko povezavo na platformo za spletno reševanje potrošniških sporov (SRPS): <a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>. Za spore, ki izhajajo iz uporabe storitev spletnega mesta, za katero veljajo ti splošni pogoji',se uporablja izključno pravo Republike Slovenije. Za vse spore in pravne postopke v zvezi s tem sporazumom, uporabo storitve ter delovanjem storitve je pristojno sodišče po prebivališču kupca.</small>
							</p>

						</div>

						<p><a href="https://www.knjigarna.com/media/wysiwyg/vklopi-razum-zahtevaj-racun.pdf" target="_blank">Vklopi razum, zahtevaj račun</a></p>
					
						<div id="generic-message" class="ui error message"></div>

					</div>

				</div>

				<div class="one column row">
					<div class="column">
						<div class="field ui" id="nav-buttons">
							<button v-on:click.prevent="goBack" class="ui button">Nazaj</button>
							<button v-on:click.prevent="submit" type="submit" name="submit" value="submit" class="ui submit yellow button" v-bind:class="{disabled: selectedPackages.length == 0, loading: loading}">Potrdi nakup</button>					
						</div>
					</div>
				</div>
					
			</div>
		 </form>
	</div>
</template>

<script>
	import store from '../store'
	import purchaseSuccess from '../modals/PurchaseSuccess.vue'

    export default {
    	props: ['teacher'],
    	data() {
    		return {
    			selectedPackages: [],
    			customer: {
    				type: null,
    				name: null,
    				surname: null,
    				address: null,
    				zip: null,
    				post: null
    			},
				loading: false
    		}
    	},
    	mounted() {
    		this.selectedPackages = store.state.cart;
    		if (this.teacher) {
    			this.customer.type = 'school';
    		} else {
				this.customer.type = 'personal';
			}
        },
        methods: {
        	goBack(event) {
        		window.location.href = this.route('nakup-gradiva');
        	},
        	submit(event) {
				this.$validator.validate().then(result => {
					if (result) {
						this.loading = true;
						axios.post(this.route('nakup-gradiva'), {
							packages: this.selectedPackages,
							customer: this.customer
						}).then((response) => {
							this.loading = false;
							if (response.status == 204) {
								store.commit('cart', []);
								this.$root.$emit('add-popup', purchaseSuccess, {
									personal: this.customer.type == 'personal' || !this.teacher
								});
							} else {
								console.error('Napaka pri pošiljanju naročila.');
							}
						});
					}
				});
        	},
        	removePackage(item) {
        		let index = this.selectedPackages.indexOf(item);
        		this.selectedPackages.splice(index, 1);
        		store.commit('cart', this.selectedPackages);
        	},
        	onImageError(event) {
        		event.currentTarget.src = '/images/no-image.png';
        	}
        },
        computed: {
        	price() {
        		let price = 0;
        		for (let i = 0; i < this.selectedPackages.length; i++) {
        			let item = this.selectedPackages[i];
        			price += item.price;
        		}
        		return price;
        	},
        	netPrice() {
        		return this.price / 1.22;
        	},
        	taxPrice() {
        		return this.price - this.netPrice;
			},
			asSchool() {
				return this.customer.type == 'school';
			},
			validation() {
                let validation = {};
				validation.name = this.teacher ? '' : { required: true };
				validation.surname = this.teacher ? '' : { required: true };
				validation.address = (!this.teacher || this.teacher && !this.asSchool) ? { required: true } : '';
				validation.zip = validation.address;
				validation.post = validation.address;
				validation.consent = { required: true };
                return validation;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/BuyPackagesConfirmation.vue